import { memo } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const otherFields = {
  lungs: 'Lungs',
  heart: 'Heart',
  thyroidGland: 'Thyroid Gland',
  breast: 'Breast',
};

const Others = ({ selectedOnExamination, setSelectedOnExamination }) => {
  const others = selectedOnExamination?.others || {
    lungs: '',
    heart: '',
    thyroidGland: '',
    breast: '',
  };

  console.log(others, "others")

  const handleData = (field, value) => {
    const updatedOthers = { ...others, [field]: value };
    setSelectedOnExamination({
      ...selectedOnExamination,
      others: updatedOthers,
    });
  };

  return (
    <div className="surgical-history">
      {Object.entries(otherFields).map(([field, label]) => (
        <Row key={field} className="mb-2">
          <Col md={3} className="pt-1">
            {label}
          </Col>
          <Col>
            <Form.Control
              size="sm"
              as="textarea"
              rows={1}
              //placeholder={`Add ${label}`}
              defaultValue={others[field] || ''}
              onChange={(e) => handleData(field, e.target.value)}
            />
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default memo(Others);
